import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { Link } from '~/components/Link'
import { logos } from '~/start/constants'
import { AppLanguage } from '~/types/locale'

export default function FeatureSection({ isMobile }: { isMobile: boolean }): React.ReactElement {
  const { t } = useTranslation('start')
  const locale = useRouter().locale as AppLanguage
  const filteredLogos = logos.filter((logo) => logo.type === locale)

  return (
    <div className="flex flex-col gap-4 w-full pt-6 px-8">
      <p className="text-blue-pastel text-md pt-4 text-left">{t('meetMind.featuredIn')}</p>
      <div className="flex flex-wrap gap-x-4 gap-y-6 md:gap-x-8 md:gap-y-10 lg:gap-x-6 bg-white rounded p-6 content-start justify-evenly">
        {filteredLogos.map((logo) => (
          <Link
            className={`flex items-center justify-center h-6 ${
              logo.link ? 'md:hover:scale-110 duration-300' : 'pointer-events-none cursor-default'
            }`}
            key={logo.srcKey}
            to={logo.link ? logo.link : '/'}
          >
            <ResponsiveImage
              alt={logo.alt}
              className="z-10"
              fit="contain"
              height={isMobile ? logo.mobileHeight : logo.height}
              key={logo.srcKey}
              srcKey={logo.srcKey}
              width={isMobile ? logo.mobileWidth : logo.width}
            />
          </Link>
        ))}
      </div>
    </div>
  )
}
